// 此组件只适用channelPage下的课程列表，如果业务需要更改此组件，请参考脑图逻辑
// http://naotu.baidu.com/file/b5602e23fe2574e6129e9cc3b5dff9f7?token=573ecd96faa03486
// update by dubinbin 2018/7/10

import React from 'react'
import {connect} from 'react-redux'
import {WKTag} from '../../components/wk'
import ChannelPageItemTag from './ChannelPageItemTag'
import {renderNewMoney, TimeStream, getJsonFromUrl} from '../../utils';
import '../../css/page/ChannelPageItemList.css'
import '../../css/wkCommon.css'
import Running from '../../images/channel/h5-playing@3x.png'

class ChannelPageItemList extends React.Component {
    constructor() {
        super()
        this.isShowPlay_Btn = false
    }
    static defaultProps = {
        border: 'bottom',
        marginBottom: false,
        attr: ''
    };


    //绘制1px细线
    renderBorder(type) {
        switch (type){
            case 'top':
                return 'currency-item-border-top';
            case 'bottom':
                return 'ChannelPageItemList_item_bottom';
            case 'none':
                return 'currency-item-border-none';
            default:
                return 'currency-item-border-top';
        }
    }

    //输出课程标签
    renderLectureTag() {
        const lecture = this.props.content;
        if (lecture.lecture_mode === 'default'){
            switch (lecture.image_mode) {
                case 'video':
                    return <ChannelPageItemTag tagName={'视频'}/>;
                case 'audio':
                    return <ChannelPageItemTag tagName={'音频'}/>;
                case 'ppt':
                    return <ChannelPageItemTag tagName={'PPT'}/>;
                default:
                    return true
            }
        }else {
            switch (lecture.lecture_mode) {
                case 'video':
                    return <ChannelPageItemTag tagName={'视频'}/>;
                case 'audio':
                    return <ChannelPageItemTag tagName={'音频'}/>;
                default:
                    return true
            }
        }
    }


    //输出左下时间或者其他开课时间相关信息new
    renderLectureTime() {
        const lecture = this.props.content;
        if(lecture.lecture_mode==='default'){//如果是直播课
            if(lecture.status ==='closed'){ //直播已经结束
                return <p>{'时长' + lecture.audio_length + '分钟'}</p>
            }else{
                return <p>{TimeStream(lecture.start_timestamp, 'MD_HM')}</p>
            }
        }else{
            if (lecture.has_uploaded_content) {
                return <p>{'时长' + lecture.audio_length + '分钟'}</p>
            } else {
                return <p className="channel-item-none">敬请期待</p>
            }
        }
    }

    //直播录播显示分支判断，输出到右边 直播 =>do sth 录播 => do sth
    isDefaultJudge(content,rate){
        this.isShowPlayBtn(true)
        if(content.lecture_mode==='default'){//直播
            if(content.status==='closed'){ //状态已结束显示进度
                return(
                    <div className="channelProgress_num">{Math.round(rate)}%</div>
                )
            }else{
                return null
            }
        }else{
            return(
                <div className="channelProgress_num">{Math.round(rate)}%</div>
           )
        }
    }

    //根据当前用户身份和各种课程状态判断是否应该给当前课程加上课程进度 以下ifxxx都同理
    ifIsNormal(){
        const {content,role,channelGranted,course_access} = this.props;
        let courseisGranted = null,study_rate = null;
            const key = content.id;
            if(typeof course_access!=='undefined' && course_access[key]){
                courseisGranted = course_access[key].access.granted ;
                study_rate = course_access[key].learning_rate;
            }else{
                courseisGranted = false;
                study_rate = 0;
            }

        if(!role.is_liveroom_vip && !role.is_manager){
            if(content.lecture_type === 'open_lecture'){  //普通用户 => 免费课
                this.isShowPlayBtn(true)
                return (
                    <div className="freeListenLecture">免费试听</div>
                )
            }else if(content.lecture_type === 'pay_lecture'){ //普通用户 => 付费课
                if(channelGranted){//判断是否购买专栏
                    return this.isDefaultJudge(content,study_rate)
                }else{
                    if(courseisGranted){  //单节课程是否付过费
                        return this.isDefaultJudge(content,study_rate)
                    }else{
                        return(
                            content.limit_money ? <p><i>￥</i>{renderNewMoney(content.limit_money.money)[0]}<span>.{renderNewMoney(content.limit_money.money)[1]}</span></p> : <p><i>￥</i>{renderNewMoney(content.money)[0]}<span>.{renderNewMoney(content.money)[1]}</span></p>
                        )
                    }
                }
            } else if(content.lecture_type === 'password_lecture'){ //普通用户 => 密码课
                if(courseisGranted){ //已解锁
                    return this.isDefaultJudge(content,study_rate)
                }else{
                    return(
                        <p>
                            <span className="addPasswordLecture">加密</span>
                        </p>
                    )
                }
            }else if(content.lecture_type === 'pay_channel'){//普通用户 => 必须购买专栏课
                if(channelGranted){ //如果购买了专栏
                    return this.isDefaultJudge(content,study_rate)
                }else{
                    return ''
                }
            }
        }
    }

    ifIsVip(){
        const {content,role,channel,channelGranted,course_access} = this.props;
        let courseisGranted = null,study_rate = null;
        const key = content.id;
        if(typeof course_access!=='undefined' && course_access[key]){
            courseisGranted = course_access[key].access.granted ;
            study_rate = course_access[key].learning_rate;
        }else{
            courseisGranted = false;
            study_rate = 0;
        }

        if(role.is_liveroom_vip){
            if(content.lecture_type === 'open_lecture'){ //VIP => 免费课
                this.isShowPlayBtn(true)
                return (
                    <div className="freeListenLecture">免费试听</div>
                )
            } else if(content.lecture_type === 'pay_lecture'){  //VIP => 付费课
                if(channel.is_relay && channelGranted){ //如果专栏是转播但是付费了
                    return this.isDefaultJudge(content,study_rate)
                }
                if(content.is_relay && !channelGranted){//转播课
                    if(courseisGranted){
                        return this.isDefaultJudge(content,study_rate)
                    }else{
                        return (
                            content.limit_money ? <p>￥{renderNewMoney(content.limit_money.money)[0]}<span>.{renderNewMoney(content.limit_money.money)[1]}</span></p> : <p>￥{renderNewMoney(content.money)[0]}<span>.{renderNewMoney(content.money)[1]}</span></p>
                        )
                    }
                }else{
                    return this.isDefaultJudge(content,study_rate)
                }
            } else if(content.lecture_type === 'password_lecture'){//VIP => 密码课
                if(courseisGranted){
                    return this.isDefaultJudge(content,study_rate)
                }else{
                    return (
                     <p>
                        <span className="addPasswordLecture">加密</span>
                    </p>
                     )
                }
            } else if(content.lecture_type === 'pay_channel'){//VIP => 必须购买专栏课
                if(channel.is_relay){//是否是转播课
                    if(channelGranted){
                        return this.isDefaultJudge(content,study_rate)
                    }else{
                        return ''
                    }
                }else{
                    return this.isDefaultJudge(content,study_rate)
                }
            }
        }
    }

    ifIsManager(){
        const {content,role,channel} = this.props;
        if(role.is_manager){
            if(channel.is_relay){
                this.isShowPlayBtn(false)
            }else{
                this.isShowPlayBtn(true)
            }
            if(content.lecture_type === 'open_lecture'){
                return  <div className="freeListenLecture">免费试听</div>
            }else if(content.lecture_type === 'password_lecture'){
                return (
                    <p>
                       <span className="addPasswordLecture">加密</span>
                   </p>
                    )
            }else{
                if(typeof content.money !== 'undefined'){
                    return (
                        content.limit_money ? <p>￥{renderNewMoney(content.limit_money.money)[0]}<span>.{renderNewMoney(content.limit_money.money)[1]}</span></p> : <p>￥{renderNewMoney(content.money)[0]}<span>.{renderNewMoney(content.money)[1]}</span></p>
                    )
                }
            }
        } 
    }

    isStudentGranted() {
        const {content, channelGranted, role, course_access, isRelay} = this.props
        let key = content.id
        // 判断付费课，加密课授权
        if (typeof course_access !== 'undefined' && course_access[key] && course_access[key].access.granted) {
            return true
        }

        // 判断免费课授权
        if (content.lecture_type === 'open_lecture') {
            return true
        }

        // 判断专栏授权 or 直播间vip
        if (channelGranted || (role.is_liveroom_vip && !isRelay)) {
            return true
        }
        return false
    }

    //显示播放按钮条件
    isShowPlayBtn(val) {
      if(val===true){
          this.isShowPlay_Btn = true
      }else {
          this.isShowPlay_Btn = false
      }
    }

    playBtnClick(e) {
        e.stopPropagation()
        const {content, type, role, ownMethod} = this.props;
        if (ownMethod) {
            ownMethod && ownMethod()
            return
        }
        if (type === 'lecture') {
            if (content.lecture_mode === 'default' && (this.isStudentGranted() || role.is_manager)) {
                window.location.href = `/classroom/${content.id}`
            }else{
                window.location.href = `/lecture/${content.id}`
            }
        }
    }

    //跳转逻辑判断
    handleClick() {
        const {content, type, attr, ownMethod, channelGranted, role} = this.props;

        if (ownMethod) {
            ownMethod && ownMethod()
            return
        }

        if(attr === 'channelIndex' && type === 'lecture' && content.lecture_type === "pay_channel" && content.lecture_mode === 'default'){//付费直播
            let access = this.props.role.is_liveroom_vip || channelGranted
            if (!this.props.role.is_manager) { //判断是否为管理员
                if (!content.is_relay) {
                    if (access) {
                        window.location.href = `/classroom/${content.id}`;
                        return
                    }
                } else {
                    if (channelGranted) {
                        window.location.href = `/classroom/${content.id}`;
                        return
                    }
                }
            }
        }

        let link = '';
        if (type === 'lecture') {
            if (content.lecture_mode === 'default' && this.props.frAccess && (this.isStudentGranted() || role.is_manager)) {
                link = `/classroom/${content.id}`
            } else {
                let params = getJsonFromUrl()
                if (params.nsid) {
                    link = `/lecture/${content.id}?nsid=${params.nsid}&st=channel_cps&lfr=${params.lfr}`
                } else {
                    link = `/lecture/${content.id}`
                }
            }
        }
        window.location.href = link
    }

    render() {
        const {content, type, marginBottom, relayShow, attr, role} = this.props;
        let render_Right_result = null;
        if(role.is_liveroom_vip){
            render_Right_result = this.ifIsVip()
        }else if(role.is_manager){
            render_Right_result = this.ifIsManager()
        } else {
            render_Right_result = this.ifIsNormal()
        }

        return (
            <div className={`ChannelPageItemList_item  wk-currency-item   ${this.renderBorder(this.props.border) +  (marginBottom ? ' currency-item-margin-bottom' : '') } `}  onClick={() => this.handleClick()}>
                <div className="currncy-item-left">
                    <div className="currency-item-img background-image"
                         style={{backgroundImage: `url(${content.cover_url})`, marginRight: 10 , width: 107, height: 61}}>
                        {this.isShowPlay_Btn && content.has_uploaded_content &&
                            <div className="Bg-playBtnArea" onClick={(e) => this.playBtnClick(e) }>
                                <span className="playBtn" onClick={(e) => this.playBtnClick(e) }>
                                </span>
                            </div>
                        }
                    </div>
                </div>

                <div className='ChannelPageItemList_right'>
                    <div className={`ChannelPageItemList_right-title currency-item-right-title ${content.has_uploaded_content ? "" : "channel-item-none"}`}>
                        {content.is_preffered &&
                        <div style={{top:2 ,position:'relative', marginRight: 7, width: 35, display: 'inline-block' }} >
                            <img src="https://staticqc.weike.fm/static/media/youxuan@3x.3ef23ad0.png" alt=""/>
                        </div>
                        }
                        {type && type === 'lecture' &&
                        (
                            content.has_uploaded_content ?
                                this.renderLectureTag()
                                :
                                <div className="channel-item-none">{this.renderLectureTag()}</div>
                        )}
                        {relayShow && content.is_relay &&
                        '【转】'
                        }
                        {content.name}
                    </div>

                    {/*已付费*/}
                    <div className="currency-item-right__container">
                        <div className="currency-item-right-mid">
                            { (content.status !== 'closed' && content.status!=='draft' && content.lecture_mode === 'default' && content.start_timestamp * 1000 < Date.parse(new Date()) && content.has_uploaded_content)  &&
                            <div className="currency-item-right-mid">
                                <div className="currency-item-right-mid__running">
                                    <img src={Running} alt=""/>
                                    正在直播
                                </div>
                            </div>
                            }
                        </div>


                        <div className="currency-item-right-bottom">
                            <div className="currency-item-right-bottom_left">
                                <div className="ChannelPageItemList-time currency-item-right-bottom_left-count-time ">
                                    {type && type === 'channel' &&
                                    <p>已更新<span>{content.lecture_count}</span>期</p>
                                    }
                                    {/*直播显示开始时间*/}
                                    {(content.lecture_mode !== 'audio' && content.lecture_mode !== 'video') && (type && type === 'lecture' && attr !== 'history') &&
                                    this.renderLectureTime()
                                    }

                                    {/*对于录播课显示时长*/}
                                    {(content.lecture_mode === 'audio' || content.lecture_mode=== 'video') && (type && type === 'lecture' && attr !== 'history') &&
                                    this.renderLectureTime()
                                    }
                                </div>

                            </div>
                            {/*负责列表右边状态的渲染*/}
                            {content.has_uploaded_content &&
                            <div className="currency-item-right-bottom_right">{render_Right_result}</div>
                            }
                        </div>
                    </div>
                </div>
            </div> 
        )
    }
}

export default connect(state => ({
    frAccess: state.channel.frAccess,
    isRelay: state.channel.channel.is_relay,
}))(ChannelPageItemList)



// WEBPACK FOOTER //
// ./src/pages/channel/ChannelPageItemList.js